var $ = jQuery.noConflict();
var imagesLoaded = require('imagesloaded');
import _gallery from './../vendor/jquery.swipebox.min';
var Isotope = require('isotope-layout');
// import AOS from './../vendor/aos';

var iso;
var iso2;
var gridHome;
var gridOffers;
var swipebox_filter;

$(document).ready(function(){
  gridHome = document.querySelector(".offers-gallery-filtr .grid");
  if ( $( gridHome ).length ) {
     isotopeHome();
  }

  if ( $( ".offers-gallery" ).length ) {
    gridOffers= document.querySelector(".offers-gallery .grid");
    isotopeOffers();
  }

  if ( $( ".grid-portfolio" ).length ) {
    isotopePortfolio();
  }
});



function isotopeHome(){
  imagesLoaded( gridHome, function() {
    var filtr =  $( ".last-work .filter-button li:first-child" ).data('filter');
     iso = new Isotope(gridHome,{
      itemSelector: '.grid-item',
      percentPosition: true,
      layoutMode: 'masonry',
      filter:  filtr
    });

    $( ".last-work .filter-button li:first-child" ).addClass('active');

     swipebox_filter = $( '.offers-gallery-filtr .grid .grid-item a' ).swipebox({
        useSVG : false,
        afterOpen : modalOpen,
        afterClose : modalClose
    });
       // AOS.init();
       AOS.refresh();
});
  

 

  $('.filter-button').on( 'click', 'li', function() {
    var filterValue = $(this).attr('data-filter');
    iso.arrange({ filter: filterValue });
    $('.filter-button li').removeClass('active');
    $(this).addClass('active');

    // swipebox_filter = $( '.offers-gallery-filtr .grid .grid-item:visible a' ).swipebox({
    //   useSVG : false,
    //   afterOpen : modalOpen,
    //   afterClose : modalClose
    // });
  });


}

function isotopePortfolio(){
  iso2 = new Isotope( '.grid-portfolio', {
    itemSelector: '.grid-item',
    masonry: {
      gutter: '.gutter-sizer'
    }
  });
}

function isotopeOffers(){
imagesLoaded( gridOffers, function() {
  iso2 = new Isotope( gridOffers, {
    itemSelector: '.grid-item'
  });

  $( '.offers-gallery .grid a' ).swipebox({
      useSVG : false,
      afterOpen : modalOpen,
      afterClose : modalClose
  });
  AOS.refresh();
});
}

function modalOpen(){
  var hash = "gallery";
  window.location.hash = hash;
  window.onhashchange = function() {
    if (!location.hash){
      $('#swipebox-close').trigger('click');
    }
  }
}

function modalClose(){
  if( window.location.hash=="#gallery"){
    window.history.back();
  }
}
